import React from 'react';
import StoryHero from '../components/story/StoryHero';
import WorldLost from '../components/story/WorldLost';
import SolarReborn from '../components/story/SolarReborn';
import HumanScale from '../components/story/HumanScale';
import FullTimeline from '../components/story/FullTimeline';
import SignalSection from '../components/story/SignalSection';
import WhyMatters from '../components/story/WhyMatters';

const StoryPage = () => (
  <main>
    <StoryHero />
    <WorldLost />
    <SolarReborn />
    <HumanScale />
    <FullTimeline />
    <SignalSection />
    <WhyMatters />
  </main>
);

export default StoryPage;